<template>
  <div style="background: #fff; min-height: 100vh">
    <div class="mod-reg mod-account" style="font-size: 0.3rem">
      <div class="header">
        <div class="header-left">
          <a @click="$parent.goNav('/app')" class="header-download white"></a>
        </div>
        <div class="header-right">
          <a @click="$parent.openKefu" class="header-helper white"></a>
        </div>
      </div>
      <div class="wrapper" v-if="infoType == 0">
        <!-- Password Login -->
        <form id="password_login_form">
          <div class="login-wrap">
            <div class="account-title">
              <p>密码登录</p>
            </div>
            <div class="gap"></div>
            <ul class="account-forms">
              <li class="acc-username">
                <label>用户名</label>
                <input type="text" name="uid" id="uid" v-model="loginInfo.name" autocomplete="off" placeholder="请输入账号" />
              </li>
              <li class="acc-password">
                <label>密码</label>
                <input :type="psw1 ? 'password' : 'text'" v-model="loginInfo.password" autocomplete="new-password" id="jpwd" placeholder="请输入登录密码" />
                <a href="javascript:void(0);" @click="changPsw('psw1')" v-if="psw1" class="verify-eye"></a>
                <a href="javascript:void(0);" @click="changPsw('psw1')" v-else class="verify-eye visible"></a>
              </li>
            </ul>

            <ul class="account-forms">
              <li class="acc-captcha">
                <label>验证码</label>
                <input type="text" name="verifycode" id="captcha_text" placeholder="请输入验证码" maxlength="4" v-model="loginInfo.code" autocomplete="off" />
                <img id="logincaptcha" style="cursor: pointer; height: 37px" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
              </li>
            </ul>
            <a @click="$parent.openKefu" class="forget-btn fr">忘记密码？</a>
            <div class="gap"></div>
            <a href="javascript:void(0);" id="gologin" class="confirm-sub" @click="login">登录</a>
            <a @click="$parent.goNav('/')" class="no-acc-path">暂不登录 先去看看</a>
          </div>
        </form>

        <!-- QuickLink -->
        <div class="quicklink">
          <a class="ql-account" @click="infoType = 1"><i></i>账号注册</a>
        </div>

        <input type="hidden" name="device_code" id="device_code" value="1918873707" />
        <input
          type="hidden"
          name="eeBlackBox"
          id="eeBlackBox"
          value="0002MDAwN0xTVE9LRU4wMDI0YTRlNDBkMTItOWIyOS00MjM2LTgyZTMtMDJkMWM4NDk4NzZlMDAwNklOVExPQzAwMmFodHRwczovL20uOTZtYW54YXBwLmNvbTo5MjUwL2FjY291bnQvbG9naW4wMDA3UFJJVkFURTAwMDVmYWxzZTAwMDVKRU5CTDAwMDExMDAwNUpTU1JDMDAyMGh0dHBzOi8vd3d3LmY0Ynp5cno5MnVzMy5jb20vRTIvMDAwNFVBR1QwMDgzTW96aWxsYS81LjAgKExpbnV4OyBBbmRyb2lkIDYuMDsgTmV4dXMgNSBCdWlsZC9NUkE1OE4pIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMDMuMC4wLjAgTW9iaWxlIFNhZmFyaS81MzcuMzYwMDA3SlNUT0tFTjAwMjRhNGU0MGQxMi05YjI5LTQyMzYtODJlMy0wMmQxYzg0OTg3NmUwMDA3SEFDQ0xORzAwMGV6aC1DTix6aDtxPTAuOTAwMDdIQUNDQ0hSMDAwZlVuaWNvZGUgKFVURi04KTAwMDVKU1ZFUjAwMDMyLjAwMDA0VFpPTjAwMDQtNDgwMDAwNkpTVElNRTAwMTcyMDIyLzA4LzA2IDA4OjMyOjUwLjI4NzAwMDdTVlJUSU1FMDAxMzgvNi8yMDIyIDg6MzI6NDQgQU0wMDA1SkJSTk0wMDBkQ2hyb21lIE1vYmlsZTAwMDVKQlJWUjAwMDkxMDMuMC4wLjAwMDA1SkJST1MwMDBiQW5kcm9pZCA2LjAwMDA1SkJSQ00wMDI3TmV4dXMgNSBCdWlsZC9NUkE1OE47IEtIVE1MLCBsaWtlIEdlY2tvMDAwNUpMQU5HMDAwNXpoLUNOMDAwNEpSRVMwMDA3Nzk1eDQ0ODAwMDZKUkVGUlIwMDI4aHR0cHM6Ly9tLjk2bWFueGFwcC5jb206OTI1MC9hY2NvdW50L3JlZzAwMDRJR0dZMDAyY3dhK2c5NE05ZERSc1ZXUFpGNkxBZXZTeDY4ME04STEyT0RsNmxjdVhlRjQ9MDAwNUFQVkVSMDA3YjUuMCAoTGludXg7IEFuZHJvaWQgNi4wOyBOZXh1cyA1IEJ1aWxkL01SQTU4TikgQXBwbGVXZWJLaXQvNTM3LjM2IChLSFRNTCwgbGlrZSBHZWNrbykgQ2hyb21lLzEwMy4wLjAuMCBNb2JpbGUgU2FmYXJpLzUzNy4zNjAwMDVBUE5BTTAwMDhOZXRzY2FwZTAwMDVOUExBVDAwMDVXaW4zMjAwMDJNVjAwMjA2QUJEOTIxRjkzMDdFOUY3MEI0RTZEQTFDQ0EzRjhEQzAwMDNFVFQwMDU4bVFWNExwUjF1NWtPSDZVUGpEc0xneFV6TlZ0aGp0amZ6LzFhQ2IwVFJqVFNmZy9SZ1VYMzBNMnVCL0dITUtvK2RhRjZjOGdOUUpYRE1XNVpXSU9GdXc9PTAwMDRFVFBUMDA1OGFrUkZMUHp3TktQNVd6MzQ1OWdYVytUekg2eWtmQmVZMEVaV3hWVnNoUFhueE43ejdGekZCb3puOWVDem12a1NKeDhVY1Q2cnlSYjJCRGxWSlFhSEJ3PT0wMDA2Q1RPS0VOMDAyNGE0ZTQwZDEyLTliMjktNDIzNi04MmUzLTAyZDFjODQ5ODc2ZTAwMDhXREJUT0tFTjAwMjRhNGU0MGQxMi05YjI5LTQyMzYtODJlMy0wMmQxYzg0OTg3NmU="
        />
      </div>
      <div class="wrapper" v-if="infoType == 1">
        <form id="reg_form">
          <div class="reg-wrap">
            <div class="account-title">
              <p>注册新用户</p>
            </div>
            <ul class="account-forms" id="step1">
              <li class="acc-username">
                <label><em>*</em>用户名</label>
                <input type="text" autocomplete="off" v-model="registerInfo.name" id="username" name="joiname" placeholder="帐号（最少6位，英文及数字）" />
                <!-- 打钩图片:icon_valid_tip.png   错误图片:icon_error_tip -->
                <span class="fr tip hide"><img src="/static/image/icon_valid_tip.png" width="22" height="22" /></span>
              </li>
              <li class="acc-password">
                <label><em>*</em>密码</label>
                <input :type="psw1 ? 'password' : 'text'" id="password" v-model="registerInfo.password" autocomplete="new-password" name="joinpwd" placeholder="密码（最少8位，英文及数字）" />
                <a href="javascript:void(0);" @click="changPsw('psw1')" v-if="psw1" class="verify-eye"></a>
                <a href="javascript:void(0);" @click="changPsw('psw1')" v-else class="verify-eye visible"></a>
              </li>
              <li class="acc-password">
                <label><em>*</em>确认密码</label>
                <input :type="psw2 ? 'password' : 'text'" v-model="registerInfo.confirmPass" name="password1" id="password1" placeholder="请再次输入密码" />
                <a href="javascript:void(0);" @click="changPsw('psw2')" v-if="psw2" class="verify-eye"></a>
                <a href="javascript:void(0);" @click="changPsw('psw2')" v-else class="verify-eye visible"></a>
              </li>

              <li class="acc-mcaptcha">
                <label><em>*</em>真实姓名</label>

                <input type="text" id="uphonetoken" v-model="registerInfo.realname" placeholder="请输入真实姓名" />
              </li>
              <li class="acc-password">
                <label><em>*</em>支付密码</label>
                <input :type="psw3 ? 'password' : 'text'" v-model="registerInfo.paypassword" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')"
 placeholder="请输入6位取款密码" />
                <a href="javascript:void(0);" @click="changPsw('psw3')" v-if="psw3" class="verify-eye"></a>
                <a href="javascript:void(0);" @click="changPsw('psw3')" v-else class="verify-eye visible"></a>
              </li>

              <li class="acc-mobile tac">
                <label><em>*</em>验证码</label>
                <input type="text" id="uphone" v-model="registerInfo.code" name="uphone" placeholder="请输入验证码" />
                <input type="button" id="tokendisabled" :style="`background:url(/static/image/yzm/${imgLis[index]}.png);background-size: 100% 100%;`" @click="changIndex" />
                <!-- <img style="cursor: pointer; height: 37px" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" /> -->
              </li>
            </ul>

            <div class="agreement">
              <label class="custom-checkbox">
                <input type="checkbox" v-model="checkbox" id="btn_agreement" />
                <span class="checkmark"></span>
                <em>*</em>
              </label>
              <a id="rulesandprivacyagreement" @click="$parent.goNav('/abouts?type=5')">我已阅读并同意相关的规则和隐私条款。</a>
            </div>
            <div class="gap"></div>
            <a href="javascript:void(0);" @click="register" class="confirm-sub mt20" id="reg_btn">注 册</a>
            <a @click="$parent.goNav('/')" class="no-acc-path">暂不登录，先去逛逛</a>
          </div>
        </form>

        <!-- QuickLink -->
        <div class="quicklink">
          <a class="ql-password" @click="infoType = 0">去登录</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      registerInfo: {},
      loginInfo: {},
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      infoType: 0, //0 是登陆 1是注册
      psw1: true,
      psw2: true,
      psw3: true,
      checkbox: true,
      pid: '',
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.infoType = query.type;
    }
    that.pid = localStorage.getItem('pid') || '';

    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  methods: {
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
      that.changIndex();
      that.loginInfo = {};
      that.registerInfo = {};
      this.psw1 = true;
      this.psw2 = true;
      this.psw3 = true;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;
      if (!that.checkbox) {
        that.$parent.showTost(0, '阅读并同意相关的规则和隐私条款！');

        return;
      }
      let info = {};
      info.name = that.registerInfo.name || '';
      info.password = that.registerInfo.password || '';
      info.confirmPass = that.registerInfo.confirmPass || '';
      info.realname = that.registerInfo.realname || '';
      info.paypassword = that.registerInfo.paypassword || '';
      let code = that.registerInfo.code || '';
      // 用户名验证
      let namereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/; //不得低于6位，以字母或数字组合！
      let passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/; //以字母或数字组合！不低于8位
      var realnamereg = /^[\u0391-\uFFE5a-zA-Z·&\\s]+$/; //中英文姓名
      let paypasswordreg = /^[0-9]{6}$/; //只能是6位
      let codereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,}$/; //以字母或数字组合 不低于4位
      if (namereg.test(info.name) == false) {
        that.$parent.showTost(0, ' 用户名长度不得低于6位，以字母和数字组合！');
        return;
      }

      if (passwordreg.test(info.password) == false) {
        that.$parent.showTost(0, '密码长度最少8位！以字母和数字组合！');
        return;
      }
      if (info.confirmPass != info.password) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (realnamereg.test(info.realname) == false) {
        that.$parent.showTost(0, '姓名格式不正确，可以是中，英文名称！');
        return;
      }

      if (paypasswordreg.test(info.paypassword) == false) {
        that.$parent.showTost(0, '支付密码长度需是6位！');
        return;
      }
      if (codereg.test(code) == false || code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.registerInfo.code = '';
        that.changIndex();
        return;
      }
      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      that.$apiFun
        .register(info)
        .then(res => {
          that.$parent.showTost(1, res.message);
          if (res.code == 200) {
            sessionStorage.setItem('token', res.data.api_token);
            that.$store.commit('changToken');
            that.$parent.getUserInfo();
            that.$parent.openDaoTime();

            that.$parent.goNav('/');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.showTost(1, '网络异常，请检查当前网络后重试！');

          that.$parent.hideLoading();
        });
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }
      let code = that.loginInfo.code;
      if (!code) {
        that.$parent.showTost(0, '请输入验证码！');

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.loginInfo.code = null;
        that.changIndex();
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .login(info)
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
            that.$parent.hideLoading();
          }
          if (res.code === 200) {
            sessionStorage.setItem('token', res.data.new_api_token);
            that.$store.commit('changToken');
            that.$parent.getUserInfo();
            that.$parent.openDaoTime();

            that.$parent.goNav('/');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.showTost(1, '网络异常，请检查当前网络后重试！');

          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../static/css/login-dialog.cf307113.css';
</style>



// WEBPACK FOOTER //
// src/components/login.vue